import { SearchAuctionFacet, SearchAuctionResult } from '@/redux/api/auctionCalendar';
import { TypedActionWithPayload } from '@/types/redux';

export const LOAD_CATALOG_SEARCH_FAIL = 'LOAD_CATALOG_SEARCH_FAIL';
export type LOAD_CATALOG_SEARCH_FAIL_ACTION = TypedActionWithPayload<typeof LOAD_CATALOG_SEARCH_FAIL, string>;

export const LOAD_CATALOG_SEARCH_REQUEST = 'LOAD_CATALOG_SEARCH_REQUEST';
export type LOAD_CATALOG_SEARCH_REQUEST_ACTION = TypedActionWithPayload<typeof LOAD_CATALOG_SEARCH_REQUEST>;

export const LOAD_CATALOG_SEARCH_SUCCESS = 'LOAD_CATALOG_SEARCH_SUCCESS';
export type LOAD_CATALOG_SEARCH_SUCCESS_ACTION = TypedActionWithPayload<
    typeof LOAD_CATALOG_SEARCH_SUCCESS,
    {
        count: number;
        facets: SearchAuctionFacet[];
        results: SearchAuctionResult[];
    }
>;

export const UPDATE_FACETS_SELECTED = 'UPDATE_FACETS_SELECTED';
export type UPDATE_FACETS_SELECTED_ACTION = TypedActionWithPayload<
    typeof UPDATE_FACETS_SELECTED,
    {
        facets: SearchAuctionFacet[];
    }
>;

export const LOAD_CATALOGS_TODAY_COUNT_FAIL = 'LOAD_CATALOGS_TODAY_COUNT_FAIL';
export type LOAD_CATALOGS_TODAY_COUNT_FAIL_ACTION = TypedActionWithPayload<
    typeof LOAD_CATALOGS_TODAY_COUNT_FAIL,
    string
>;

export const LOAD_CATALOGS_TODAY_COUNT_REQUEST = 'LOAD_CATALOGS_TODAY_COUNT_REQUEST';
export type LOAD_CATALOGS_TODAY_COUNT_REQUEST_ACTION = TypedActionWithPayload<typeof LOAD_CATALOGS_TODAY_COUNT_REQUEST>;

export const LOAD_CATALOGS_TODAY_COUNT_SUCCESS = 'LOAD_CATALOGS_TODAY_COUNT_SUCCESS';
export type LOAD_CATALOGS_TODAY_COUNT_SUCCESS_ACTION = TypedActionWithPayload<
    typeof LOAD_CATALOGS_TODAY_COUNT_SUCCESS,
    {
        count: number;
    }
>;
